export default {
    locale: "ru",
    resetButton: true,
    dateFormatOptions: { year: "numeric", month: "numeric", day: "numeric" },
    startWeekday: 1,
    labelPrevDecade: "Предыдущее десятилетие",
    labelPrevYear: "Предыдущий год",
    labelPrevMonth: "Предыдущий месяц",
    labelCurrentMonth: "Текущий месяц",
    labelNextMonth: "Следующий месяц",
    labelNextYear: "Следующий год",
    labelNextDecade: "Следующее десятилетие",
    labelToday: "Сегодня",
    labelSelected: "Выбранная дата",
    labelNoDateSelected: "Дата не выбрана",
    labelCalendar: "Календарь",
    labelNav: "Навигация по календарю",
    labelHelp: "Используйте курсор для навигации по датам",
    labelResetButton: "Очистить",
};
